/** Keep limits aligned with `be/utils/emailAttachmentParse.js`. */
export const EMAIL_ATTACHMENT_MAX_FILES = 10;
export const EMAIL_ATTACHMENT_MAX_FILE_BYTES = 10 * 1024 * 1024;
export const EMAIL_ATTACHMENT_MAX_TOTAL_BYTES = 15 * 1024 * 1024;

/**
 * @param {File[]} files
 * @returns {{ ok: true, files: File[] } | { ok: false, error: string }}
 */
export function validateFilesForEmail(files) {
  if (!files?.length) {
    return { ok: true, files: [] };
  }
  if (files.length > EMAIL_ATTACHMENT_MAX_FILES) {
    return { ok: false, error: `Maximum ${EMAIL_ATTACHMENT_MAX_FILES} attachments.` };
  }
  let total = 0;
  for (const f of files) {
    if (f.size > EMAIL_ATTACHMENT_MAX_FILE_BYTES) {
      return {
        ok: false,
        error: `File "${f.name}" exceeds ${EMAIL_ATTACHMENT_MAX_FILE_BYTES / (1024 * 1024)} MB.`
      };
    }
    total += f.size;
  }
  if (total > EMAIL_ATTACHMENT_MAX_TOTAL_BYTES) {
    return {
      ok: false,
      error: `Total attachment size exceeds ${EMAIL_ATTACHMENT_MAX_TOTAL_BYTES / (1024 * 1024)} MB.`
    };
  }
  return { ok: true, files };
}

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error(`Failed to read file: ${file.name}`));
    reader.readAsDataURL(file);
  });
}

/**
 * @param {File[]} files
 * @returns {Promise<Array<{ filename: string, contentType: string, content: string }>>}
 */
export async function filesToEmailAttachmentPayloads(files) {
  const payloads = [];
  for (const file of files) {
    const dataUrl = await readFileAsDataUrl(file);
    const comma = dataUrl.indexOf(',');
    const content = comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl;
    payloads.push({
      filename: file.name,
      contentType: file.type || 'application/octet-stream',
      content
    });
  }
  return payloads;
}
